import M from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import Api from "../../../Services/Api";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleDate from "../../../modules/SimpleDate";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import { mapToObjectDDL, removeNullFields } from "../../common/mapper";
import {
  contructQueryParam,
  fetchDataAsync,
  getUserAccess,
} from "../../../Services/Utils";
import ErrorAction from "../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import { ACTIVITY_TYPE, HttpStatus } from "../../common/Constants";
import SimpleInput from "../../../modules/SimpleInput";
import { formGroup } from "./config";
import MasterPromoH2Modifying from "./components/masterPromoH2Modifying";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import MasterPromoFilter from "./components/MasterPromoFilter";
import SimpleAlert from "../../../modules/popup/SimpleAlert";

const DATE_FORMAT = "DD-MM-YYYY";

class MasterPromoH2 extends Component {
  getIconsAksi = (type = "preview") => {
    const iconMap = {
      edit: "pencil-alt",
      delete: "trash",
      preview: "eye",
      copy: "copy",
    };

    const accessMap = {
      edit: this.state.userAccess.updateAccess,
      delete: this.state.userAccess.deleteAccess,
      preview: true,
      copy: this.state.userAccess.createAccess,
    };

    const iconClass = iconMap[type] || iconMap.preview;
    const hasAccess = accessMap[type] ?? accessMap.preview;
    const color = hasAccess ? "red" : "grey";

    return (
      <i
        className={`fa fa-lw fa-${iconClass}`}
        style={{
          backgroundColor: "transparent",
          color,
          fontSize: 20,
        }}
      />
    );
  };

  tableColumns = [
    {
      name: "id",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
        setCellProps: () => ({
          style: { width: "5%" },
        }),
      },
    },
    {
      name: "promoId",
      label: "Promo ID",
    },
    {
      name: "promoName",
      label: "Nama Promo",
    },
    {
      name: "startDate",
      label: "Tgl Mulai",
    },
    {
      name: "endDate",
      label: "Tgl Selesai",
    },
    {
      name: "gracePeriode",
      label: "Grace Periode",
    },
    {
      name: "cabangBerlaku",
      label: "Cabang Berlaku",
    },
    {
      name: "status",
      label: "Status",
    },
    {
      name: "id",
      label: "Aksi",
      options: {
        customBodyRender: (val, tableMeta) => (
          <FlexView>
            <SimpleButton
              category="action_button"
              className="btnAct margin-right-15px"
              styles={{ backgroundColor: "transparent" }}
              icon={this.getIconsAksi("preview")}
              onClick={() =>
                this.handleModifyingVisibility(
                  ACTIVITY_TYPE.VIEW,
                  tableMeta.rowIndex
                )
              }
            />
            <SimpleButton
              category="action_button"
              disabled={!this.state.userAccess.updateAccess}
              className="btnAct margin-right-15px"
              styles={{ backgroundColor: "transparent" }}
              icon={this.getIconsAksi("edit")}
              onClick={() =>
                this.handleModifyingVisibility(
                  ACTIVITY_TYPE.UPDATE,
                  tableMeta.rowIndex
                )
              }
            />
            <SimpleButton
              category="action_button"
              disabled={!this.state.userAccess.createAccess}
              className="btnAct margin-right-15px"
              styles={{ backgroundColor: "transparent" }}
              icon={this.getIconsAksi("copy")}
              // onClick={() => {
              //     this.handleDetailVisibility(val, 'edit');
              // }}
              onClick={() => this.handleCopyModalVisibility(tableMeta.rowIndex)}
            />
            <SimpleButton
              category="action_button"
              disabled={!this.state.userAccess.updateAccess}
              className="btnAct margin-right-15px"
              styles={{ backgroundColor: "transparent" }}
              icon={this.getIconsAksi("delete")}
              onClick={() => this.handleDeleteAlertModalVisibility(val)}
            />
          </FlexView>
        ),
        setCellProps: () => ({
          style: { width: "5%" },
        }),
        sort: false,
      },
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      detail: {
        poNo: "",
        visible: false,
      },
      filterVisible: false,
      loading: false,
      searchData: {
        namaPromo: null,
      },
      filterData: {},
      submittedFilterData: {},
      kodeCabang: null,
      pagination: {
        totalData: 1,
        page: 1,
        limit: 5,
      },
      cabangOptions: [],
      dataTable: [],
      userAccess: {},
      skipPagination: false,
      modifyingVisible: false,
      copyVisible: false,
      errorAlert: false,
    };
  }

  componentDidMount = async () => {
    await this.fetchDataCabang();
  };

  componentDidUpdate(_, prevState) {
    if (
      (prevState.pagination.page !== this.state.pagination.page ||
        prevState.pagination.limit !== this.state.pagination.limit) &&
      !this.state.skipPagination
    ) {
      this.fetchData(
        this.state.submittedFilterData,
        this.state.pagination.page,
        this.state.pagination.limit
      );
    }
    if (this.state.skipPagination) {
      this.setState({ skipPagination: false });
    }
  }

  fetchDataCabang = async () => {
    try {
      this.handleTriggerLoading();

      const res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();

      if (res.ok && Array.isArray(res.data?.data)) {
        const allowedCabang = this.props.menuAccess.map(
          (item) => item.idRefObj
        );

        const filteredData = res.data.data.filter((item) =>
          allowedCabang.includes(item.kodeCabang)
        );

        if (filteredData.length > 0) {
          const ddlOptions = filteredData.map((item) =>
            mapToObjectDDL(item.namaDealer, item.kodeCabang)
          );

          const defaultCabang = ddlOptions[0];

          this.setState((prevState) => ({
            ...prevState,
            dataCabang: filteredData,
            cabangOptions: ddlOptions,
            kodeCabang: defaultCabang,
            userAccess: getUserAccess(
              this.props.menuAccess,
              defaultCabang?.value
            ),
          }));

          this.fetchData({ kodeCabang: defaultCabang?.value });
        }
      }
    } catch (error) {
      console.error("Error fetchDataCabang:", error);
    } finally {
      this.handleTriggerLoading();
    }
  };

  fetchData = async (filter = {}, page = 1, limit = 5) => {
    const userId = localStorage.getItem("userId");
    try {
      this.handleTriggerLoading();

      this.setState({
        lastFilter: filter,
        lastPage: page,
        lastLimit: limit,
      });

      const payload = {
        ...filter,
        kodeCabang: [].concat(
          filter?.kodeCabang || this.state.kodeCabang?.value || []
        ),
        userId,
        page,
        limit,
      };

      let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMainPagePromoH23,
        menuName: "Master Promo H23",
        setError: this.props.setError,
        args: payload,
      });

      if (response.ok && response.data?.status === "S") {
        const data = response.data?.data || [];
        const totalData = response.data?.totalData || 0;

        const formattedData = data.map((item) => ({
          ...item,
          startDate: item.startDate
            ? M(item.startDate, "DD-MM-YYYY").format("DD-MM-YYYY")
            : "",
          endDate: item.endDate
            ? M(item.endDate, "DD-MM-YYYY").format("DD-MM-YYYY")
            : "",
        }));

        this.setState((prev) => ({
          ...prev,
          dataTable: formattedData,
          pagination: {
            ...prev.pagination,
            totalData,
            page,
            limit,
          },
        }));
      } else {
        this.setState({ dataTable: [] });
      }
    } catch (error) {
      console.error("Error fetchData:", error);
    } finally {
      this.handleTriggerLoading();
    }
  };

  //   this.setState((prevValue) => ({
  //     ...prevValue,
  //     dataTable: dummyData,
  //     pagination: {
  //       ...prevValue.pagination,
  //       totalData: dummyData.length,
  //     },
  //   }));
  // };

  handleModifyingVisibility = (at, id) => {
    this.setState((prevValue) => ({
      ...prevValue,
      activityType: at,
      modifyingVisible: !prevValue.modifyingVisible,
      selectedData: prevValue.dataTable[id],
    }));
  };

  handleCopyModalVisibility = (rowIndex) => {
    const id = this.state.dataTable[rowIndex]?.id;
    this.setState((prevValue) => ({
      ...prevValue,
      selectedCopyID: id,
      copyVisible: !prevValue.copyVisible,
    }));
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleSearchValueChange = (name, event) => {
    const value = event?.target?.value ?? "";

    this.setState((prevState) => ({
      ...prevState,
      searchData: {
        ...prevState.searchData,
        [name]: value,
      },
    }));
  };

  handleSearch = async () => {
    try {
      const { kodeCabang, searchData } = this.state;

      const request = {
        kodeCabang: kodeCabang?.value ? [kodeCabang.value] : [],
        namaPromo: searchData?.namaPromo || null,
      };

      await this.fetchData(request);
      this.setState((prev) => ({
        ...prev,
        submittedFilterData: request,
        loading: false,
        skipPagination: true,
      }));
    } catch (error) {
      this.setState({ loading: false });
    }
  };

  handleStateChange = (callback) => {
    this.setState(callback);
  };

  handleSubmitFilter = async (data) => {
    try {
      const request = {
        promoId: data?.promoId || null,
        namaPromo: data?.namaPromo || null,
        startDate: data?.startDate || null,
        endDate: data?.endDate || null,
        combination: data?.combination?.value ?? null,
        wilayah: data?.wilayah?.value ?? null,
        kodeCabang: data?.kodeCabang
          ? data.kodeCabang.map((item) => item.value)
          : Array.isArray(this.state.kodeCabang.value)
          ? this.state.kodeCabang.value
          : [this.state.kodeCabang.value].filter(Boolean),
        status: data?.status?.value ?? null,
      };

      await this.fetchData(request);

      this.setState({
        submitedFilter: data,
        submittedFilterData: request,
        filterVisible: false,
        loading: false,
        skipPagination: true,
      });
    } catch (error) {
      console.error("Error saat submit filter:", error);
      this.setState({ loading: false });
    }
  };

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleLoadingVisibility = () => {
    this.setState((prev) => ({
      ...prev,
      loading: !prev.loading,
    }));
  };

  handleRefresh = async () => {
    const initialSearch = {
      namaPromo: null,
    };
    this.setState((prev) => ({
      ...prev,
      pagination: {
        totalData: 1,
        page: 1,
        limit: 5,
      },
      skipPagination: true,
    }));

    this.handleLoadingVisibility();

    await this.fetchData({
      kodeCabang: this.state.kodeCabang.value,
    });

    this.setState((prevValue) => ({
      ...prevValue,
      searchData: initialSearch,
      filterData: {},
    }));
    this.handleLoadingVisibility();
  };

  handleCabangChange = async (name, value) => {
    this.setState(
      (prevValue) => ({
        ...prevValue,
        [name]: value,
        userAccess: getUserAccess(this.props.menuAccess, value.value),
      }),
      () => this.handleRefresh()
    );
  };

  handleDetailVisibility = (poNo = "", aksi) => {
    this.setState((prevValue) => ({
      ...prevValue,
      detail: {
        poNo: poNo,
        cabang: this.state.kodeCabang,
        visible: !prevValue.detail.visible,
        aksi,
      },
    }));
  };

  handleCloseModalDetail = (refresh) => {
    if (refresh) {
      this.handleRefresh();
    }
    this.setState((prev) => ({
      ...prev,
      detail: {
        ...prev.detail,
        poNo: null,
        aksi: null,
        visible: !prev.detail.visible,
      },
    }));
  };

  handleValueChange = ({ target }) => {
    this.setState((prevValue) => ({
      ...prevValue,
      inputValue: target.value,
    }));
  };

  handleCopy = async (e) => {
    e.preventDefault();
    const { inputValue, selectedCopyID } = this.state;

    if (!inputValue) {
      this.setState({ errorMessage: "Nama Promo wajib diisi" });
      return;
    }

    try {
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getCopyDataPromoH2,
        setError: this.props.setError,
        menuName: "Master Promo",
        args: contructQueryParam({
          promoId: selectedCopyID,
          promoName: inputValue,
        }),
      });

      if (res.ok) {
        this.setState({
          inputValue: "",
          selectedCopyID: null,
          copyVisible: false,
          errorMessage: "",
        });
        // this.handleModifyingVisibility();
        this.handleTriggerLoading();
        await this.refetch();
        this.handleTriggerLoading();
      } else {
        this.handleErrorAlertModalVisibility(res.data.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ errorMessage: "Terjadi kesalahan server" });
    }
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  refetch = async (page = 1, limit = 5) => {
    const { lastFilter = {} } = this.state;
    await this.fetchData(lastFilter, page, limit);
  };

  handleSubmitData = async (data) => {
    this.handleTriggerLoading();

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").createMasterPromoH23,
      menuName: "Master Promo H23",
      setError: this.props.setError,
      args: data,
    });

    if (res?.ok && res?.data?.status === HttpStatus.SUCCESS) {
      this.handleModifyingVisibility();
      await this.refetch();
      this.handleTriggerLoading();
      return;
    } else {
      this.handleErrorAlertModalVisibility(
        res?.data?.message || "Terjadi kesalahan"
      );
    }

    this.handleTriggerLoading();
  };

  handleDeleteAlertModalVisibility = (id) => {
    const text = "Apakah anda yakin ingin menghapus data ini ?";
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      deleteAlert: !prevState.deleteAlert,
      selectedId: id,
    }));
  };

  handleDeleteData = async (id) => {
    this.handleTriggerLoading();

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteMasterPromoH2,
      menuName: "Master Promo H23",
      setError: this.props.setError,
      args: id,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleDeleteAlertModalVisibility();
      await this.refetch();
      this.handleTriggerLoading();
      return;
    } else {
      this.handleDeleteAlertModalVisibility();
      this.handleErrorAlertModalVisibility(res.data.message);
    }

    this.handleTriggerLoading();
  };

  handleErrorAlertModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      errorAlert: !prevState.errorAlert,
    }));
  };

  render() {
    return (
      <>
        <Container>
          <FlexView
            style={{ justifyContent: "space-between" }}
            vAlignContent="center"
            className="margin-top-5px"
          >
            <FlexView vAlignContent="center" style={{ gap: "30px" }}>
              <SimpleDDL
                id="select_options_nama_cabang"
                box="search"
                name="kodeCabang"
                containerclassname="width width-250px"
                placeholder="Nama cabang hak akses"
                options={this.state.cabangOptions}
                value={this.state.kodeCabang}
                onChange={(value, { name }) =>
                  this.handleCabangChange(name, value)
                }
              />
              <SimpleInput
                id="input_text_nama_promo"
                placeholder="Nama Promo"
                name="namaPromo"
                containerclassname="margin-bottom-16px width width-250px"
                value={this.state.searchData?.namaPromo || ""}
                onChange={(e) => this.handleSearchValueChange("namaPromo", e)}
              />
              <SimpleButton
                className="margin-bottom-20px"
                onClick={this.handleSearch}
              >
                Cari
              </SimpleButton>
            </FlexView>
            <SimpleButton
              type="button"
              category="action_button"
              className="btn background-red margin-bottom-20px"
              onClick={this.handleFilterVisibility}
              icon={<i className="fa fa-qrcode"></i>}
            />
          </FlexView>
          <SimpleDataTable
            data={this.state.dataTable}
            columns={this.tableColumns}
            rowsPerPage={this.state.pagination.limit}
            page={this.state.pagination.page - 1}
            toCount={this.state.pagination.totalData}
            options={defaultTableChange(
              this.handleChangePage,
              this.handleRowsPerPage
            )}
            footerAdditionalButtons={
              <>
                <SimpleButton
                  disabled={!this.state.userAccess?.createAccess}
                  secondary={!this.state.userAccess?.createAccess}
                  icon={<i className="fa fa-plus margin-right-10px" />}
                  onClick={() =>
                    this.handleModifyingVisibility(ACTIVITY_TYPE.CREATE, null)
                  }
                >
                  Tambah
                </SimpleButton>
              </>
            }
          />
        </Container>
        {this.state.modifyingVisible && (
          <MasterPromoH2Modifying
            {...this.props}
            formGroup={formGroup}
            initialValues={this.state.selectedData}
            visible={this.state.modifyingVisible}
            dataCabang={this.state.dataCabang}
            onSubmit={this.handleSubmitData}
            onClickClose={() => this.handleModifyingVisibility()}
            onDelete={() =>
              this.handleShowAlert(this.state.selectedData?.promoId)
            }
            tab={this.props.tab}
            activityType={this.state.activityType}
          />
        )}

        {this.state.filterVisible && (
          <MasterPromoFilter
            {...this.props}
            visible={this.state.filterVisible}
            dataCabang={this.state.dataCabang}
            submitedFilter={this.state.submitedFilter}
            onClickClose={this.handleFilterVisibility}
            triggerLoading={this.handleTriggerLoading}
            onSubmit={this.handleSubmitFilter}
          />
        )}

        {this.state.copyVisible && (
          <SimpleModal
            visible={this.state.copyVisible}
            onClickClose={() => this.handleCopyModalVisibility()}
            styles={{
              width: "600px",
              minWidth: "600px",
            }}
            content={
              <ModalContainer style={{ padding: "20px" }}>
                <form onSubmit={this.handleCopy}>
                  <SimpleInput
                    id="input_text_nama_package"
                    name="promoName"
                    label="Nama Promo"
                    mandatory
                    errorMessage={this.state.errorMessage}
                    value={this.state.inputValue}
                    onChange={this.handleValueChange}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px",
                    }}
                  >
                    <SimpleButton type="submit">SIMPAN</SimpleButton>
                  </div>
                </form>
              </ModalContainer>
            }
          />
        )}

        {this.state.deleteAlert && (
          <SimpleAlert
            title={"Information"}
            content={
              <div>
                <p>{this.state.warningMessage}</p>
              </div>
            }
            visible={this.state.deleteAlert}
            onClickClose={this.handleDeleteAlertModalVisibility}
            additionalButtons={
              <FlexView vAlignContent="center" style={{ alignItems: "end" }}>
                <SimpleButton
                  type="button"
                  text="Batal"
                  onClick={() => this.handleDeleteAlertModalVisibility()}
                />
                <SimpleButton
                  type="button"
                  text="OK"
                  onClick={() => this.handleDeleteData(this.state.selectedId)}
                />
              </FlexView>
            }
          />
        )}

        {this.state.errorAlert && (
          <SimpleAlert
            title={"Information"}
            content={
              <div>
                <p>{this.state.warningMessage}</p>
              </div>
            }
            visible={this.state.errorAlert}
            onClickClose={this.handleErrorAlertModalVisibility}
            additionalButtons={
              <FlexView vAlignContent="center" style={{ alignItems: "end" }}>
                <SimpleButton
                  type="button"
                  text="OK"
                  onClick={() => this.handleErrorAlertModalVisibility()}
                />
              </FlexView>
            }
          />
        )}

        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(MasterPromoH2);
